import StockoutListTable from './stockoutListTable.container';

export default StockoutListTable